<template>  
  <div class="rew19_infoImg">    
    <img src="https://resource2018.nuskinkorea.co.kr/images/aro/info_nourish.png" 
      alt="온라인에서 정기기부프로그램을 신청하면 매월 자동적으로 정해진 날짜에 정해진 수량의 타이타밀을 구매하여 공인 구호 단체로 기부하게되는 시스템으로, 구매에 대한 번거로움없이 정기적으로 영양결핍에 시달리고있는 어린이들에게 따뜻한 생명의 식사를 나누어 줄 수 있습니다" 
      class="viewPc" @click="onClickMoveIntroduce"/>
    <img src="https://resource2018.nuskinkorea.co.kr/images/aro/info_nourish_mb.png" 
      alt="온라인에서 정기기부프로그램을 신청하면 매월 자동적으로 정해진 날짜에 정해진 수량의 타이타밀을 구매하여 공인 구호 단체로 기부하게되는 시스템으로, 구매에 대한 번거로움없이 정기적으로 영양결핍에 시달리고있는 어린이들에게 따뜻한 생명의 식사를 나누어 줄 수 있습니다" 
      class="viewMb" @click="onClickMoveIntroduce"/>
  </div>
</template>
<script>
export default {
  name: 'ProductListBannerNtc',
  components: {  },
  props: {},
  data() {
    return {
    }
  },
  mounted() {
    let _this = this;
  },
  methods :{
    onClickMoveIntroduce(){
      let _this = this;

      _this.$router.push(`${_this.$aroBasePath}/nourishIntroduce`);
    }
  }
}
</script>
<style>
div.rew19_infoImg img{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/banner/ProductListBannerNtc.vue